import React from "react";
import {
  Box,
  Button,
  Icon,
  Input,
  Link,
  Text,
} from "@chakra-ui/react";
import { FiUpload } from "react-icons/fi";

const FileUploadTab = ({
  file,
  isUploadLoading,
  handleFileUpload,
  handleDrop,
  handleDragOver,
  handleUploadFile,
  handleDownloadTemplate,
}) => (
  <>
    <Box
      display="flex"
      h="45vh"
      width="100%"
      textAlign="center"
      justifyContent="center"
      alignItems="center"
    >
      <Box
        border="1px dashed"
        borderColor="gray.200"
        borderRadius="md"
        p={4}
        width="50%"
        cursor="pointer"
        position="relative"
        onClick={() => document.getElementById("file-upload")?.click()}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        <Icon as={FiUpload} boxSize={20} mb={4} />
        <Text fontWeight="bold" mb={2}>
          Drop the files here or <Link color="#3C9AFF">choose a file</Link>
        </Text>
        <Text fontSize="sm" color="gray.500">
          .xlsx, csv
        </Text>
        <Link fontSize="sm" color="#3C9AFF" onClick={handleDownloadTemplate}>
          download template here
        </Link>
        <Input
          id="file-upload"
          type="file"
          opacity={0}
          position="absolute"
          inset={0}
          cursor="pointer"
          onChange={handleFileUpload}
        />
        {file && (
          <Text fontSize="sm" mt={2}>
            {file.name}
          </Text>
        )}
      </Box>
    </Box>

    <Box display="flex" justifyContent="flex-end" mt={4}>
      <Button
        bg="#231F1F"
        color="#FFFFFF"
        _hover={{ bg: "#404040" }}
        borderRadius="full"
        size="sm"
        onClick={handleUploadFile}
        isLoading={isUploadLoading}
      >
        Upload File
      </Button>
    </Box>
  </>
);

export default FileUploadTab;